import {
  DatePickerInput as MDateInput,
  DatePickerInputProps,
} from "@mantine/dates";
import { ForwardedRef, forwardRef } from "react";
import styles from "./date-input.module.scss";

type TDateInputProps = DatePickerInputProps;

export const DateInput = forwardRef(
  ({ ...props }: TDateInputProps, ref?: ForwardedRef<HTMLButtonElement>) => {
    return (
      <MDateInput
        {...props}
        ref={ref}
        valueFormat="YYYY-MM-DD"
        size="md"
        classNames={{
          input: styles.custom_input,
        }}
      />
    );
  },
);
